import(/* webpackMode: "eager", webpackExports: ["ClientApp"] */ "/Users/chiyu/Desktop/app develop/desktop-tutorial/zalureai/apps/web/app/[[...slug]]/client-app.tsx");
